import { useAuth } from "oidc-react";
import { useEffect } from "react";
import Box from "../ui/Box";
import Modal from "../ui/Modal";
import LoadingSection from "./LoadingSection";

const revokeToken = (token: string) => {
  const body = new URLSearchParams();
  body.append("token", token);
  body.append("client_id", process.env.REACT_APP_AUTHORITY_CLIENT_ID || "");
  return fetch(
    `${process.env.REACT_APP_AUTHORITY_API_URL}/connect/revocation`,
    {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body,
      keepalive: true
    }
  ).catch(() => undefined);
};

const Logout = () => {
  const auth = useAuth();
  useEffect(() => {
    const accessToken = auth?.userData?.access_token;
    const refreshToken = auth?.userData?.refresh_token;

    if (accessToken) void revokeToken(accessToken);
    if (refreshToken) void revokeToken(refreshToken);

    void auth?.signOut().catch(() => undefined);

    Object.keys(localStorage)
      .filter((k) => k.startsWith("oidc."))
      .forEach((k) => localStorage.removeItem(k));

    window.location.href = "/login";
  }, []);

  return (
    <Modal show={true} onClose={() => 0} hasHeader={false} position="top" modalWidthTouch="">
      <Box className="w-[300px] h-[450px] flex flex-col justify-center items-center"
        shadow={false}
        rounded={false}>
        <LoadingSection />
      </Box>
    </Modal>
  );
};

export default Logout;
